var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubstractSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Assets / Icons / Line / subtract-square") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DS_Suez_PCE_Atoms",
    transform: "translate(-437.000000, -678.000000)",
    fill: "#030F40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-fill-color",
    transform: "translate(437.000000, 678.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.25,0 C22.3210678,0 24,1.67893219 24,3.75 L24,20.25 C24,22.3210678 22.3210678,24 20.25,24 L3.75,24 C1.67893219,24 0,22.3210678 0,20.25 L0,3.75 C0,1.67893219 1.67893219,0 3.75,0 L20.25,0 Z M20.25,1.5 L3.75,1.5 C2.50735931,1.5 1.5,2.50735931 1.5,3.75 L1.5,20.25 C1.5,21.4926407 2.50735931,22.5 3.75,22.5 L20.25,22.5 C21.4926407,22.5 22.5,21.4926407 22.5,20.25 L22.5,3.75 C22.5,2.50735931 21.4926407,1.5 20.25,1.5 Z M16.5,11.25 C16.9142136,11.25 17.25,11.5857864 17.25,12 C17.25,12.4142136 16.9142136,12.75 16.5,12.75 L16.5,12.75 L7.5,12.75 C7.08578644,12.75 6.75,12.4142136 6.75,12 C6.75,11.5857864 7.08578644,11.25 7.5,11.25 L7.5,11.25 Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstractSquare);
export default __webpack_public_path__ + "static/media/substract-square.ec5712d4.svg";
export { ForwardRef as ReactComponent };